// extracted by mini-css-extract-plugin
export default {"wrapper":"cmbv4","inherit":"R4G8q","title":"yqr1p","titleCenter":"Z0Buk","titleText":"wCVdP","titleArrow":"WmvFH","opened":"ewBi1","content":"Tkadx","indexed":"ruuuc"};